import { ReactAuthWrapper } from '@carrier-sce-sharedpackages/reactauthwrapper';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ProSidebarProvider } from 'react-pro-sidebar';
import { Provider } from 'react-redux';
import App from './App';
import { appConfig } from './appConfig';
import reportWebVitals from './reportWebVitals';
import { store } from './sagas/store';
import './i18n/i18nConfig';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
//To get the api for different enviornment
const getAPI = () => {
  let api = 'https://api-pecr.carrier.com/';
  if (window.location.hostname.includes('localhost')) {
    api = 'http://localhost:8080/';
  } else if (window.location.hostname.includes('dev-pecr')) {
    api = 'https://devapi-pecr.carrier.com/';
  }
  return api;
};
const apiConfig1 = {
  uiURL: getAPI(),
};
export function APIHeader() {
  return new Headers({
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem('msal.idtoken'),
  });
}
//API header for uploading docs
export function APIHeaderForUpload() {
  return new Headers({
    Accept: 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem('msal.idtoken'),
  });
}

const url = new URL(window.location);
const params = new URLSearchParams(url.search);
const pecrId = params.get('PECRId');
localStorage.setItem('pecrId', pecrId);

root.render(
  <Provider store={store}>
    <ProSidebarProvider>
      <ReactAuthWrapper appConfig={appConfig}>
        <App apiConfig={apiConfig1} />
      </ReactAuthWrapper>
    </ProSidebarProvider>
  </Provider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
